function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Web_1280_1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 723.41,
  height: 869.8
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web_1280_1",
  "data-name": "Web 1280 \\u2013 1",
  clipPath: "url(#clip-Web_1280_1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 723.41,
  height: 869.8,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_334",
  "data-name": "Group 334",
  transform: "translate(-715 -2201)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1179",
  "data-name": "Path 1179",
  d: "M1347.915,2196.053s4.914,467.557-334.343,276.5S891.6,2669.407,767.153,2770.381s0,225.159,0,225.159,85.149,78.922,218.332,46.425c3.021-.737-233.983,54.113,0,0s165.932-47.585,362.43-46.425S1347.915,2196.053,1347.915,2196.053Z",
  transform: "translate(3.158 5)",
  fill: "#ffc6c6"
}), /*#__PURE__*/React.createElement("g", {
  id: "company-02-01",
  transform: "translate(715 2525.075)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  transform: "translate(30.434 4.659)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_260",
  "data-name": "Group 260",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_15",
  "data-name": "Line 15",
  y1: 20.917,
  x2: 142.214,
  transform: "translate(7.43 66.45)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_16",
  "data-name": "Line 16",
  x1: 111.579,
  y1: 47.168,
  transform: "translate(7.43 87.368)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_17",
  "data-name": "Line 17",
  x1: 69.744,
  y1: 126.926,
  transform: "translate(149.645 66.45)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_18",
  "data-name": "Line 18",
  x1: 283.599,
  y1: 35.494,
  transform: "translate(119.009 134.535)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_19",
  "data-name": "Line 19",
  y1: 73.714,
  x2: 100.32,
  transform: "translate(219.389 119.662)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_20",
  "data-name": "Line 20",
  x1: 82.899,
  y1: 50.368,
  transform: "translate(319.709 119.662)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_21",
  "data-name": "Line 21",
  x1: 71.937,
  y1: 142.214,
  transform: "translate(402.608 170.03)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_22",
  "data-name": "Line 22",
  x2: 255.156,
  y2: 118.867,
  transform: "translate(219.389 193.377)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_23",
  "data-name": "Line 23",
  x1: 74.84,
  y2: 185.471,
  transform: "translate(327.768 170.03)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  x1: 148.377,
  y2: 42.724,
  transform: "translate(326.168 312.244)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  x2: 55.76,
  y2: 123.904,
  transform: "translate(63.249 10.631)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_26",
  "data-name": "Line 26",
  y1: 76.736,
  x2: 55.819,
  transform: "translate(7.43 10.631)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_27",
  "data-name": "Line 27",
  x1: 34.309,
  y2: 66.663,
  transform: "translate(293.459 355.501)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_28",
  "data-name": "Line 28",
  x1: 181.086,
  y2: 109.92,
  transform: "translate(293.459 312.244)",
  fill: "none",
  stroke: "#95719b",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_259",
  "data-name": "Group 259",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_211",
  "data-name": "Ellipse 211",
  cx: 6.163,
  cy: 6.163,
  r: 6.163,
  transform: "translate(0 91.878) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_212",
  "data-name": "Ellipse 212",
  cx: 8.77,
  cy: 8.77,
  r: 8.77,
  transform: "translate(52.608 17.026) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_213",
  "data-name": "Ellipse 213",
  cx: 6.163,
  cy: 6.163,
  r: 6.163,
  transform: "translate(396.249 176.76) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_214",
  "data-name": "Ellipse 214",
  cx: 6.163,
  cy: 6.163,
  r: 6.163,
  transform: "translate(285.986 426.633) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_215",
  "data-name": "Ellipse 215",
  cx: 8.77,
  cy: 8.77,
  r: 8.77,
  transform: "translate(308.269 126.596) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_216",
  "data-name": "Ellipse 216",
  cx: 8.77,
  cy: 8.77,
  r: 8.77,
  transform: "translate(107.4 138.728) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_217",
  "data-name": "Ellipse 217",
  cx: 6.163,
  cy: 6.163,
  r: 6.163,
  transform: "translate(213.346 200.414) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_218",
  "data-name": "Ellipse 218",
  cx: 6.163,
  cy: 6.163,
  r: 6.163,
  transform: "translate(320.191 357.504) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_219",
  "data-name": "Ellipse 219",
  cx: 8.77,
  cy: 8.77,
  r: 8.77,
  transform: "translate(463.908 318.67) rotate(-76.101)",
  fill: "#95719b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_220",
  "data-name": "Ellipse 220",
  cx: 8.77,
  cy: 8.77,
  r: 8.77,
  transform: "translate(140.533 72.676) rotate(-76.101)",
  fill: "#95719b"
})))), /*#__PURE__*/React.createElement("g", {
  id: "afa8f846-9f09-4e7c-bda3-49d724cd1542",
  transform: "translate(0 10.431)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_221",
  "data-name": "Ellipse 221",
  cx: 262.504,
  cy: 32.295,
  rx: 262.504,
  ry: 32.295,
  transform: "translate(0 396.6)",
  fill: "#ca8998"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1294",
  "data-name": "Path 1294",
  d: "M263.507,452.811v150.51L160.994,620.505,49,606.876v-151.1L160.994,445.7Z",
  transform: "translate(-19.965 -190.129)",
  fill: "#c3b5cb",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1295",
  "data-name": "Path 1295",
  d: "M160.994,468.033v159.4L49,613.8V462.7Z",
  transform: "translate(-19.965 -197.055)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1296",
  "data-name": "Path 1296",
  d: "M263.507,452.811l-102.513,8.3L49,455.774,160.994,445.7Z",
  transform: "translate(-19.965 -190.129)",
  fill: "#fff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1297",
  "data-name": "Path 1297",
  d: "M639.692,624.959v56.293l-71.7,16L424,685.4V635.032l2.37-.415h.237l124.2-20.917,87.343,11.081Z",
  transform: "translate(-172.755 -258.579)",
  fill: "#e7f5f6",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1298",
  "data-name": "Path 1298",
  d: "M567.992,657.711v53.923L424,699.782V649.415l2.37-.415Z",
  transform: "translate(-172.755 -272.962)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1299",
  "data-name": "Path 1299",
  d: "M639.944,624.781l-70.159,18.547L428.4,634.617,552.6,613.7Z",
  transform: "translate(-174.547 -258.579)",
  fill: "#fff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1300",
  "data-name": "Path 1300",
  d: "M345,553.7V669.249a157.492,157.492,0,0,0,78.218,0V553.7Z",
  transform: "translate(-140.567 -234.133)",
  fill: "#de3f41",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_222",
  "data-name": "Ellipse 222",
  cx: 39.109,
  cy: 4.444,
  rx: 39.109,
  ry: 4.444,
  transform: "translate(204.433 315.42)",
  fill: "#de3f41",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_223",
  "data-name": "Ellipse 223",
  cx: 39.109,
  cy: 4.444,
  rx: 39.109,
  ry: 4.444,
  transform: "translate(204.433 315.123)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1301",
  "data-name": "Path 1301",
  d: "M476.044,284.4c.533,1.244,1.067,2.489,1.659,3.733l-1.244.593c-.593-1.244-1.126-2.489-1.659-3.733Z",
  transform: "translate(-193.453 -124.409)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1302",
  "data-name": "Path 1302",
  d: "M66.9,521.454H91.373a86,86,0,0,0,0-29.154H66.9A52.992,52.992,0,0,1,66.9,521.454Z",
  transform: "translate(-27.258 -209.116)",
  fill: "#de3f41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1303",
  "data-name": "Path 1303",
  d: "M147.417,573.454H122.944a86,86,0,0,1,0-29.154h24.473A52.992,52.992,0,0,0,147.417,573.454Z",
  transform: "translate(-49.585 -230.303)",
  fill: "#e7f5f6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1304",
  "data-name": "Path 1304",
  d: "M143.9,653.454h24.473a86,86,0,0,0,0-29.154H143.9A52.992,52.992,0,0,1,143.9,653.454Z",
  transform: "translate(-58.631 -262.898)",
  fill: "#de3f41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1305",
  "data-name": "Path 1305",
  d: "M164.681,306.56a70.044,70.044,0,1,0-32.472,26.073,22.644,22.644,0,1,0,32.472-26.073Z",
  transform: "translate(-14.882 -88.972)",
  fill: "#de3f41",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1110",
  "data-name": "Rectangle 1110",
  width: 83.255,
  height: 6.577,
  transform: "translate(50.012 164.554)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1111",
  "data-name": "Rectangle 1111",
  width: 83.255,
  height: 6.577,
  transform: "translate(50.012 175.516)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1112",
  "data-name": "Rectangle 1112",
  width: 83.255,
  height: 6.577,
  transform: "translate(50.012 186.479)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_261",
  "data-name": "Group 261",
  transform: "translate(170.065 43.257)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1113",
  "data-name": "Rectangle 1113",
  width: 162.361,
  height: 90.425,
  fill: "#c3b5cb",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1114",
  "data-name": "Rectangle 1114",
  width: 102.335,
  height: 3.022,
  transform: "translate(29.806 34.605)",
  fill: "#fff",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1115",
  "data-name": "Rectangle 1115",
  width: 102.335,
  height: 3.022,
  transform: "translate(29.806 46.575)",
  fill: "#fff",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1116",
  "data-name": "Rectangle 1116",
  width: 102.335,
  height: 3.022,
  transform: "translate(29.806 58.604)",
  fill: "#fff",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1117",
  "data-name": "Rectangle 1117",
  width: 162.361,
  height: 10.074,
  transform: "translate(0 0.059)",
  fill: "#de3f41",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_224",
  "data-name": "Ellipse 224",
  cx: 3.674,
  cy: 3.674,
  r: 3.674,
  transform: "translate(2.963 1.718)",
  fill: "#e7f5f6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_225",
  "data-name": "Ellipse 225",
  cx: 3.674,
  cy: 3.674,
  r: 3.674,
  transform: "translate(12.918 1.718)",
  fill: "#e7f5f6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_226",
  "data-name": "Ellipse 226",
  cx: 3.674,
  cy: 3.674,
  r: 3.674,
  transform: "translate(22.873 1.718)",
  fill: "#e7f5f6"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_264",
  "data-name": "Group 264",
  transform: "translate(319.174 53.33)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_262",
  "data-name": "Group 262",
  transform: "translate(0.119)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_227",
  "data-name": "Ellipse 227",
  cx: 25.895,
  cy: 25.895,
  r: 25.895,
  transform: "translate(44.006 17.718)",
  fill: "#571d44",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1306",
  "data-name": "Path 1306",
  d: "M577.188,254.032l-7.229,16.355-7.7-23.051s-.948-20.206-7.7-19.258-.948,20.206-.948,20.206,4.326,42.783,13.925,40.413,15.881-16.355,15.881-16.355l1.659-14.755Z",
  transform: "translate(-543.907 -154.778)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1307",
  "data-name": "Path 1307",
  d: "M637.089,207.152s2.9,15.881-3.378,19.258,24.058,2.43,24.532-2.9c0,0-6.755-16.355-6.755-20.206Z",
  transform: "translate(-577.143 -144.696)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1308",
  "data-name": "Path 1308",
  d: "M562.9,429.7s2.429,27.376,3.378,33.183a111.69,111.69,0,0,1,.948,14.4,228.056,228.056,0,0,0-1.422,36.561l1.422,14.932h11.081l.415-1.955,4.385-20.621s4.8-16.829,2.9-29.332l5.274-40.413Z",
  transform: "translate(-548.64 -236.94)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1309",
  "data-name": "Path 1309",
  d: "M620.6,445.9s11.555,36.087,14.4,39.879,6.755,12.5,6.755,12.5,8.177,20.206,12.5,23.584l4.8,8.651,8.177-2.43L664.8,508.83a60.463,60.463,0,0,0-11.555-29.806l-5.274-32.235Z",
  transform: "translate(-572.15 -243.541)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1310",
  "data-name": "Path 1310",
  d: "M639.335,235.541s-14.221,3.733-19.614,2.074c0,0-5.392-.178-7.289.3s-13.925,4.8-13.925,5.748,2.43,10.607,2.43,10.607-1.422,5.748-.948,9.6-8.651,15.881-3.852,16.829,7.7-.948,10.074.948,31.228,10.607,31.228,10.607L661.5,244.666s-3.852-8.177-7.229-8.177S641.943,234,641.943,234Z",
  transform: "translate(-561.612 -157.204)",
  fill: "#c3b5cb",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1311",
  "data-name": "Path 1311",
  d: "M599.047,250.767l-2.37-1.067s-9.125,13.155-6.34,14.7c2.844,1.541,9.9,5.155,9.9,5.155Z",
  transform: "translate(-559.604 -163.601)",
  fill: "#c3b5cb",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1312",
  "data-name": "Path 1312",
  d: "M577.153,309.6l-7.7,12.5s-12.029,1.9-12.977,18.251c0,0-8.177,2.9-10.073,17.777,0,0-12.029,7.7-5.748,16.355s39.879,25.954,75.492,20.206c0,0,6.755-13.451,1.9-22.577,0,0,5.155-9.718-3.674-16.414,0,0,7.525-9.6-.178-20.147l.474-15.407Z",
  transform: "translate(-538.835 -188.007)",
  fill: "#adb0d8",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1313",
  "data-name": "Path 1313",
  d: "M570.884,594.4H557.432s-.474,12.029-5.748,14.933-15.407,18.251-7.7,20.206,30.28-12.5,30.28-15.881S570.884,594.4,570.884,594.4Z",
  transform: "translate(-539.795 -304.046)",
  fill: "#571d44",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1314",
  "data-name": "Path 1314",
  d: "M692.955,581.4,681.4,585.726s8.651,23.584,8.651,26.9,1.422,7.229,10.073,5.748,7.229-8.177,7.229-8.177Z",
  transform: "translate(-596.922 -298.749)",
  fill: "#571d44",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_228",
  "data-name": "Ellipse 228",
  cx: 14.933,
  cy: 14.933,
  r: 14.933,
  transform: "translate(49.813 36.976)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1315",
  "data-name": "Path 1315",
  d: "M681.979,279.6s-6.755,24.058-7.7,25.954l-15.881,40.887s1.9,20.68-5.274,17.3-.474-21.154-.474-21.154l11.081-43.731L669.95,279.6h12.029Z",
  transform: "translate(-584.05 -175.784)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1316",
  "data-name": "Path 1316",
  d: "M690.3,245.5l5.748,3.852s4.8,18.725,0,18.251-15.881,2.43-16.355,1.422S690.3,245.5,690.3,245.5Z",
  transform: "translate(-596.219 -161.89)",
  fill: "#c3b5cb",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_229",
  "data-name": "Ellipse 229",
  cx: 10.725,
  cy: 10.725,
  r: 10.725,
  transform: "translate(67.235 5.807)",
  fill: "#571d44",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1317",
  "data-name": "Path 1317",
  d: "M644.752,115.125a10.768,10.768,0,0,1,9.6-10.666,7.174,7.174,0,0,0-1.126-.059,10.725,10.725,0,1,0,0,21.451h0a7.173,7.173,0,0,0,1.126-.059A10.725,10.725,0,0,1,644.752,115.125Z",
  transform: "translate(-581.073 -104.4)",
  fill: "#571d44",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_230",
  "data-name": "Ellipse 230",
  cx: 17.836,
  cy: 10.725,
  rx: 17.836,
  ry: 10.725,
  transform: "translate(47.739 24.473)",
  fill: "#571d44",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_231",
  "data-name": "Ellipse 231",
  cx: 1.185,
  cy: 2.904,
  rx: 1.185,
  ry: 2.904,
  transform: "translate(79.441 48.294)",
  fill: "#a0616a",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_263",
  "data-name": "Group 263"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_232",
  "data-name": "Ellipse 232",
  cx: 25.895,
  cy: 25.895,
  r: 25.895,
  transform: "translate(44.006 17.718)",
  fill: "#571d44"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1318",
  "data-name": "Path 1318",
  d: "M576.888,254.032l-7.229,16.355-7.7-23.051s-.948-20.206-7.7-19.258-.948,20.206-.948,20.206,4.326,42.783,13.925,40.413,15.881-16.355,15.881-16.355l1.659-14.755Z",
  transform: "translate(-543.666 -154.778)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1319",
  "data-name": "Path 1319",
  d: "M636.889,207.152s2.9,15.881-3.378,19.258,24.058,2.43,24.532-2.9c0,0-6.755-16.355-6.755-20.206Z",
  transform: "translate(-576.943 -144.696)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1320",
  "data-name": "Path 1320",
  d: "M562.7,429.7s2.43,27.376,3.378,33.183a111.69,111.69,0,0,1,.948,14.4,228.052,228.052,0,0,0-1.422,36.561l1.422,14.932h11.081l.415-1.955,4.385-20.621s4.8-16.829,2.9-29.332l5.274-40.413Z",
  transform: "translate(-548.44 -236.94)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1321",
  "data-name": "Path 1321",
  d: "M620.3,445.9s11.555,36.087,14.4,39.879,6.755,12.5,6.755,12.5,8.177,20.206,12.5,23.584l4.8,8.651,8.177-2.43L664.5,508.83a60.463,60.463,0,0,0-11.555-29.806l-5.274-32.235Z",
  transform: "translate(-571.909 -243.541)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1322",
  "data-name": "Path 1322",
  d: "M639.135,235.541s-14.221,3.733-19.614,2.074c0,0-5.392-.178-7.289.3s-13.925,4.8-13.925,5.748,2.43,10.607,2.43,10.607-1.422,5.748-.948,9.6-8.651,15.881-3.852,16.829,7.7-.948,10.073.948,31.228,10.607,31.228,10.607L661.3,244.666s-3.852-8.177-7.229-8.177S641.743,234,641.743,234Z",
  transform: "translate(-561.412 -157.204)",
  fill: "#c3b5cb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1323",
  "data-name": "Path 1323",
  d: "M598.747,250.767l-2.37-1.067s-9.125,13.155-6.34,14.7,9.9,5.155,9.9,5.155Z",
  transform: "translate(-559.363 -163.601)",
  fill: "#c3b5cb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1324",
  "data-name": "Path 1324",
  d: "M576.953,309.6l-7.7,12.5s-12.029,1.9-12.977,18.251c0,0-8.177,2.9-10.073,17.777,0,0-12.029,7.7-5.748,16.355s39.82,26.013,75.433,20.206c0,0,6.755-13.451,1.9-22.577,0,0,5.155-9.718-3.674-16.414,0,0,7.525-9.6-.178-20.147l.474-15.407Z",
  transform: "translate(-538.635 -188.007)",
  fill: "#adb0d8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1325",
  "data-name": "Path 1325",
  d: "M570.683,594.4H557.232s-.474,12.029-5.748,14.933-15.407,18.251-7.7,20.206,30.28-12.5,30.28-15.881S570.683,594.4,570.683,594.4Z",
  transform: "translate(-539.595 -304.046)",
  fill: "#571d44"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1326",
  "data-name": "Path 1326",
  d: "M692.655,581.4,681.1,585.726s8.651,23.584,8.651,26.9,1.422,7.229,10.073,5.748,7.229-8.177,7.229-8.177Z",
  transform: "translate(-596.681 -298.749)",
  fill: "#571d44"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_233",
  "data-name": "Ellipse 233",
  cx: 14.933,
  cy: 14.933,
  r: 14.933,
  transform: "translate(49.813 36.976)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1327",
  "data-name": "Path 1327",
  d: "M681.779,279.6s-6.755,24.058-7.7,25.954l-15.881,40.887s1.9,20.68-5.274,17.3-.474-21.154-.474-21.154l11.081-43.731L669.75,279.6h12.029Z",
  transform: "translate(-583.849 -175.784)",
  fill: "#a0616a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1328",
  "data-name": "Path 1328",
  d: "M690.1,245.5l5.748,3.852s4.8,18.725,0,18.251-15.881,2.43-16.355,1.422S690.1,245.5,690.1,245.5Z",
  transform: "translate(-596.019 -161.89)",
  fill: "#c3b5cb"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_234",
  "data-name": "Ellipse 234",
  cx: 10.725,
  cy: 10.725,
  r: 10.725,
  transform: "translate(67.175 5.807)",
  fill: "#571d44"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1329",
  "data-name": "Path 1329",
  d: "M644.452,115.125a10.768,10.768,0,0,1,9.6-10.666,7.172,7.172,0,0,0-1.126-.059,10.725,10.725,0,1,0,0,21.451h0a7.172,7.172,0,0,0,1.126-.059A10.725,10.725,0,0,1,644.452,115.125Z",
  transform: "translate(-580.832 -104.4)",
  fill: "#571d44"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_235",
  "data-name": "Ellipse 235",
  cx: 17.836,
  cy: 10.725,
  rx: 17.836,
  ry: 10.725,
  transform: "translate(47.739 24.473)",
  fill: "#571d44"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_236",
  "data-name": "Ellipse 236",
  cx: 1.185,
  cy: 2.904,
  rx: 1.185,
  ry: 2.904,
  transform: "translate(79.441 48.294)",
  fill: "#a0616a"
}))), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_237",
  "data-name": "Ellipse 237",
  cx: 25.48,
  cy: 25.48,
  r: 25.48,
  transform: "translate(218.062 240.164)",
  fill: "#de3f41",
  stroke: "#724279",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_238",
  "data-name": "Ellipse 238",
  cx: 4.859,
  cy: 4.859,
  r: 4.859,
  transform: "translate(191.752 188.197)",
  fill: "#de3f41"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_239",
  "data-name": "Ellipse 239",
  cx: 4.859,
  cy: 4.859,
  r: 4.859,
  transform: "translate(165.206)",
  fill: "#c3b5cb"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_240",
  "data-name": "Ellipse 240",
  cx: 4.859,
  cy: 4.859,
  r: 4.859,
  transform: "translate(486.551 360.217)",
  fill: "#c3b5cb"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_241",
  "data-name": "Ellipse 241",
  cx: 4.859,
  cy: 4.859,
  r: 4.859,
  transform: "translate(469.011 76.736)",
  fill: "#de3f41"
})))));

var SvgCompanyGirlBack = function SvgCompanyGirlBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 723.41,
    height: 869.8,
    viewBox: "0 0 723.41 869.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanyGirlBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/companyGirlBack.eff0c9c5.svg";
export { ForwardRef as ReactComponent };